var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6L5.25 10.5H0.25L2.75 6ZM0.75 0.5H4.75V4.5H0.75V0.5ZM2.75 16.5C3.28043 16.5 3.78914 16.2893 4.16421 15.9142C4.53929 15.5391 4.75 15.0304 4.75 14.5C4.75 13.9696 4.53929 13.4609 4.16421 13.0858C3.78914 12.7107 3.28043 12.5 2.75 12.5C2.21957 12.5 1.71086 12.7107 1.33579 13.0858C0.960714 13.4609 0.75 13.9696 0.75 14.5C0.75 15.0304 0.960714 15.5391 1.33579 15.9142C1.71086 16.2893 2.21957 16.5 2.75 16.5ZM6.75 1.5V3.5H18.75V1.5H6.75ZM6.75 15.5H18.75V13.5H6.75V15.5ZM6.75 9.5H18.75V7.5H6.75V9.5Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrailIcon);
export default __webpack_public_path__ + "static/media/audit-trail-icon.d98b4fbd381bc60b71776ebfc49acb78.svg";
export { ForwardRef as ReactComponent };